import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { Component, EventEmitter, OnInit, Input } from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import moment from "moment";

@Component({
  selector: 'app-edit-status-modal',
  templateUrl: './edit-status-modal.component.pug',
  styleUrls: ['./edit-status-modal.component.scss'],
  standalone: false
})
export class EditStatusModalComponent implements OnInit {
  data: any;
  @Input()
  selectedPeople: any;
  public nextClick: EventEmitter<any> = new EventEmitter();
  statusOptions = [
    {value: "Candidate", label: 3},
    {value: "Employee", label: 1},
    {value: "Ex-employee", label: 0}
  ]
  options = [
    {"label": "Candidate", "value": 3},
    {"label": "Employee", "value": 1},
    {"label": "Ex-employee", "value": 0}
  ]
  rehireStatusOptions = [
    {value: "Leave unchanged", label: -1},
    {value: "Target", label: 0},
    {value: "Potential target", label: 1},
    {value: "No target", label: 2},
    {value: "Unknown", label: 3}
  ]
  departments:Array<any> = [];
  selectedStatus: any;
  selectedDepartment: any;
  selectedDate: any;
  selectedRehireStatus: any;
  title: any;
  today: Date = new Date();
  datepicker:Boolean = false;
  config = { showWeekNumbers: false, dateInputFormat: moment.localeData().longDateFormat('L') };
  profileStatusLabel = $localize`Select profile status`;
  departmentLabel = $localize`Select a department`;
  rehireStatusLabel = $localize`Leave unchanged`;
  rehireStatusHeading = $localize`Target status `;
  department = $localize`Department `;
  disableNext = true;
  showRehireStatus = false;
  constructor(private modalService: BsModalService,
    private OrganisationService: OrganisationService,
                    ) { }

  ngOnInit(): void {
    this.title = this.setTitle();
    this.fetchDepartments();
  }

  closeModal(){
    this.modalService.hide();
  }

  editStatus() {
    let emitData: any = {
      status: this.selectedStatus,
      department: this.selectedDepartment,
      date: this.selectedDate
    };

    if (this.selectedStatus && this.selectedStatus.value === 'Candidate') {
      emitData.rehireStatus = this.selectedRehireStatus;
    }

    this.nextClick.emit(emitData);
    this.modalService.hide(1);
  }

  selectStatus(option) {
    this.selectedStatus = option;

    if (option && option.value === 'Candidate') {
      this.showRehireStatus = true;
      // Set default to "Leave unchanged" if not already set
      if (!this.selectedRehireStatus) {
        this.selectedRehireStatus = this.rehireStatusOptions.find(opt => opt.label === -1);
      }
    } else {
      // Hide dropdown and clear selection for non-Candidate statuses
      this.showRehireStatus = false;
      this.selectedRehireStatus = null;
    }

    this.validateRequiredFields();
  }
  selectDepartment(option) {
    this.selectedDepartment = option;
    this.validateRequiredFields();
  }
  selectRehireStatus(option) {
    this.selectedRehireStatus = option;
    this.validateRequiredFields();
  }
  setTitle() {
    return this.selectedPeople.length > 1 ? $localize`Edit ${this.selectedPeople.length} people` : $localize`Edit ${this.selectedPeople.length} person`;
  }
  onDateSelect(date: any) {
    this.selectedDate = moment(date).format('L');
    this.datepicker = !this.datepicker;
    this.validateRequiredFields();
  }
  openDatePicker() {
    this.datepicker = !this.datepicker;
    this.validateRequiredFields();
  }

  fetchDepartments() {
    this.OrganisationService.getAllDepartments().subscribe(
      resp => {
        this.departments = resp.departments.map((item) => {
          return { value: item.department, label: item.id }
        });
        return this.departments;
      });
  }

  validateRequiredFields() {
    if (this.selectedStatus) {
      if ((!this.selectedStatus && !this.selectedDepartment)
        || ((this.selectedStatus.value === 'Employee'
        || this.selectedStatus.value === 'Ex-employee')
        && !this.selectedDate)) {
        this.disableNext = true;
      }
      else {
        this.disableNext = false;
      }
    }
    else {
      if ((!this.selectedStatus
        && !this.selectedDepartment)) {
        this.disableNext = true;
      }
      else {
        this.disableNext = false;
      }
    }
  }
}
